import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { BasePage, StaticContext, Helmet } from '@sm/webassets';
import { Grid } from '@wds/grid';

import UCSModule from '../../components/UCSModule';

import getCanonicalUrlOrNoIndex from '~app/helpers/getCanonicalUrlOrNoIndex';
import makeLinksStatic from '~app/helpers/makeLinksStatic';

import './developer-web-base-page.scss';
import ModernHeader from '../components/ModernHeader';

const fixLanguagerDropdown = (domain, subdomain) => {
  const languageButtons = document.querySelectorAll('.sm-footer [class^="wrenchMenuContainer"] button');
  languageButtons.forEach(languageButton => {
    languageButton.addEventListener('click', () => {
      setTimeout(() => {
        const languageMenuItems = document.querySelectorAll(
          '.sm-footer [class^="wrenchMenuContainer"] [class^="wrenchList"] a'
        );
        if (languageMenuItems) {
          makeLinksStatic([...languageMenuItems], domain, subdomain);
        }
      });
    });
  });
};

const DeveloperWebBasePage = ({ id, title, header, footer, pageMetricsAttributes, children }) => {
  const {
    environment: { subdomain, domain, tld },
    user,
    url,
  } = useContext(StaticContext);
  const { noIndex, canonicalUrl } = getCanonicalUrlOrNoIndex(subdomain, domain, tld, url);

  const [postRenderFooter, setPostRenderFooter] = useState(false);

  useEffect(() => {
    if (postRenderFooter) {
      // make relative footer links static
      const staticFooter = document.getElementsByClassName('sm-footer')[0];
      if (staticFooter) {
        makeLinksStatic([...staticFooter.getElementsByTagName('a')], domain, subdomain);

        fixLanguagerDropdown(domain, subdomain);
      }
    }
  }, [postRenderFooter, domain, subdomain]);

  useEffect(() => {
    setPostRenderFooter(footer);
  }, [domain, footer]);

  return (
    <BasePage
      pageId={id}
      includeHeader={false}
      includeFooter={postRenderFooter}
      pageMetricsAttributes={pageMetricsAttributes}
      wrenchVariant="developer"
      legacyWeb="developerweb"
    >
      <Helmet>
        <title>{title}</title>
        <If condition={!noIndex}>
          <link rel="canonical" href={canonicalUrl} />
        </If>
        <If condition={noIndex}>
          <meta name="robots" content="noindex, nofollow" />
        </If>
      </Helmet>
      {header}
      <If condition={user.isAuthenticated}>
        <UCSModule moduleName="top_bar" customLoader={<div />} />
      </If>
      <div className="sm-developer-web-base-page">
        <Grid noGutters noBleeds fluid>
          <Grid.Item>{children}</Grid.Item>
        </Grid>
      </div>
    </BasePage>
  );
};

DeveloperWebBasePage.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  footer: PropTypes.bool,
  header: PropTypes.node,
  children: PropTypes.node.isRequired,
  pageMetricsAttributes: PropTypes.shape({}),
};

DeveloperWebBasePage.defaultProps = {
  header: <ModernHeader />,
  pageMetricsAttributes: null,
  footer: true,
};

export default DeveloperWebBasePage;
